import Alpine from "alpinejs";
import { getCSRFToken } from "./htmx-helpers";

export const registerAvatarUpload = (Alpine: any) => {
  Alpine.data(
    "avatarUpload",
    (uploadingLabel: string, errorLabel: string, uploadUrl: string = "/api/settings/avatar") => ({
      uploading: false,
      error: false,
      errorMessage: errorLabel,

      async upload(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;

        const file = input.files[0];

        // Pre-flight size check against the server-injected cap (SSoT:
        // service.UploadCaps["avatar"], enforced server-side via MaxBytesReader).
        // Reading the injected value keeps client and server in sync; fail OPEN
        // (skip the check) if the config is absent — the server still enforces.
        const avatarCap = (globalThis as any).STUDIO_CONFIG?.uploadManager?.uploadCaps?.avatar;
        if (typeof avatarCap === "number" && avatarCap > 0 && file.size > avatarCap) {
          this.error = true;
          input.value = "";
          return;
        }

        this.uploading = true;
        this.error = false;

        const formData = new FormData();
        formData.append("avatar", file);

        try {
          const response = await fetch(uploadUrl, {
            method: "POST",
            body: formData,
            headers: {
              "HX-Request": "true",
              "X-CSRF-Token": getCSRFToken(),
            },
          });

          if (!response.ok) {
            throw new Error("Upload failed");
          }

          // If success, HTMX might handle the UI update via HX-Trigger "profile-updated"
          // but since we are using fetch, we need to dispatch the event manually.
          document.body.dispatchEvent(new CustomEvent("profile-updated"));

          // Reset input
          input.value = "";
        } catch (err) {
          console.error("Avatar upload error:", err);
          this.error = true;
          this.errorMessage = errorLabel;
        } finally {
          this.uploading = false;
        }
      },
    }),
  );
};
